<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-date-picker v-model="formDatas.slsYear" type="year" value-format="yyyy" @change="partserch"
                        placeholder="选择年" size="mini" style="width: 150px">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.slsMonth" type="month" value-format="yyyyMM" @change="partserch"
                        placeholder="选择月" size="mini" style="width: 150px; margin-left: 10px">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.slsDate" type="date" value-format="yyyyMMdd" @change="partserch"
                        placeholder="选择日" size="mini" style="width: 150px; margin-left: 10px">
                    </el-date-picker>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen(1)"
                        v-if="!dialog">柱状图</el-button>
                    <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen(2)"
                        v-if="dialog">表格</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div style="height: 100%;" v-if="dialog">
                <div ref="eCharts1" style="width: 100%;height: 100%;" v-if="dialog"></div>
            </div>
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading" v-if="dialog == false">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>
        <el-dialog title="活跃用户时间段分布" :visible.sync="diaDetail" width="80%" :close-on-click-modal="false"
            :before-close="handleClose">
            <div ref="eCharts2" style="width: 100%;height: 500px;"></div>
        </el-dialog>
    </div>
</template>

<script>
import qs from 'qs';
import {
    getSysLogStatisticsListTwo, getSysLogStatisticsDetailsTwo
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            diaDetail: false,
            tableDataDetail: [],
            dialog: false,
            totalCount: 100,
            tableLoading: false,
            tableHight: 520,
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            echartsStr: "",
            echartsStrValue: {
                dataX: [],
                dataY: [],
                dataZ: []
            },
            echartsStr2: "",
            echartsStrValue2: {
                dataX: [],
                dataY: [],
                dataZ: []
            },
            gradientColors: [
                { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#a8c8ff' }, { offset: 1, color: '#73a6ff' }] },
                { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#a8f0d0' }, { offset: 1, color: '#73d1a4' }] },
                { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#d1c4e9' }, { offset: 1, color: '#b39ddb' }] },
                { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#fff59d' }, { offset: 1, color: '#fff176' }] },
                { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#ffccd5' }, { offset: 1, color: '#ff9aa2' }] },
            ],
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                { field: "slsYear", key: "slsYear", title: "年份", align: "center", width: 120 },
                { field: "slsDate", key: "slsDate", title: "日期", align: "center", width: 120 },
                { field: "slsUserNum", key: "slsUserNum", title: "活跃用户数量", align: "center", width: 120 },
                { field: "slsLogNum", key: "slsLogNum", title: "日志数量", align: "center", width: 120 },
                {
                    field: "slsStatus", key: "slsStatus", title: "状态", align: "center", width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.slsStatus == 1 ? <el-tag size="mini" type="danger">待处理</el-tag> : '已处理';
                    },
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 90,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button size="mini" type="text" style="color: green" on-click={() => this.handleDetail(row)}>
                                    时间段
                                </el-button>
                            </span>
                        );
                    },
                },
            ],
            tableData: [],
            formDatas: {
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.$nextTick(() => {
            this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                this.tableHight = val - 200 - val * 0.04;
            });
        },
    },
    deactivated() {},
    created() {
        this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        this.getList();
    },
    mounted() {},
    methods: {
        handleDetail(row) {
            getSysLogStatisticsDetailsTwo({ slsId: row.slsId }).then(res => {
                this.tableDataDetail = res.data;
                this.diaDetail = true;
                this.getEChartValueTable2();
                this.$nextTick(() => {
                    this.DrawEcharts2();
                });
            });
        },
        handleClose() {
            this.diaDetail = false;
            this.tableDataDetail = [];
            if (this.echartsStr2) {
                this.echartsStr2.dispose();
                this.echartsStr2 = null;
            }
        },
        BoxOpen(val) {
            if (val == 1) {
                this.dialog = true;
            } else {
                this.dialog = false;
                if (this.echartsStr) {
                    this.echartsStr.dispose();
                    this.echartsStr = null;
                }
            }
            if (this.dialog) {
                this.getEChartValueTable();
                this.$nextTick(() => {
                    this.DrawEcharts();
                });
            }
        },
        DrawEcharts() {
            var that = this;
            that.echartsStr = that.$echarts.init(that.$refs.eCharts1);
            that.echartsStr.setOption({
                title: { text: '', left: 'center' },
                legend: { top: '10px', left: 'center', data: ['人数', '日志数量'] },
                tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
                grid: { left: '3%', right: '4%', bottom: '1%', containLabel: true },
                xAxis: { type: 'category', data: that.echartsStrValue.dataX },
                yAxis: [
                    { type: 'value', name: '人数' },
                    { type: 'value', name: '日志数量' }
                ],
                series: [
                    {
                        name: '人数', type: 'bar', barWidth: '20%',
                        data: that.echartsStrValue.dataY,
                        itemStyle: { color: function(params) { return that.gradientColors[params.dataIndex % that.gradientColors.length]; } }
                    },
                    {
                        name: '日志数量', type: 'line', yAxisIndex: 1,
                        data: that.echartsStrValue.dataZ,
                        itemStyle: { color: function(params) { return that.gradientColors[params.dataIndex % that.gradientColors.length]; } }
                    }
                ]
            });
        },
        getEChartValueTable() {
            this.echartsStrValue = { dataX: [], dataY: [], dataZ: [] };
            this.tableData.forEach(item => {
                this.echartsStrValue.dataX.push(item.slsDate);
                this.echartsStrValue.dataY.push(item.slsUserNum);
                this.echartsStrValue.dataZ.push(item.slsLogNum);
            });
        },
        DrawEcharts2() {
            var that = this;
            that.echartsStr2 = that.$echarts.init(that.$refs.eCharts2);
            that.echartsStr2.setOption({
                title: { text: '', left: 'center' },
                legend: { top: '10px', left: 'center', data: ['人数', '日志数量'] },
                tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
                grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
                xAxis: { type: 'category', data: that.echartsStrValue2.dataX },
                yAxis: [
                    { type: 'value', name: '人数' },
                    { type: 'value', name: '日志数量' }
                ],
                series: [
                    {
                        name: '人数', type: 'bar', barWidth: '40%',
                        data: that.echartsStrValue2.dataY,
                        itemStyle: { color: function(params) { return that.gradientColors[params.dataIndex % that.gradientColors.length]; } }
                    },
                    {
                        name: '日志数量', type: 'line', yAxisIndex: 1,
                        data: that.echartsStrValue2.dataZ,
                        itemStyle: { color: function(params) { return that.gradientColors[params.dataIndex % that.gradientColors.length]; } }
                    }
                ]
            });
        },
        getEChartValueTable2() {
            this.echartsStrValue2 = { dataX: [], dataY: [], dataZ: [] };
            this.tableDataDetail.forEach(item => {
                this.echartsStrValue2.dataX.push(item.slsTime + ':00');
                this.echartsStrValue2.dataY.push(item.slsUserNum);
                this.echartsStrValue2.dataZ.push(item.slsLogNum);
            });
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getSysLogStatisticsListTwo(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getSysLogStatisticsListTwo(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getSysLogStatisticsListTwo(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
